import { useEffect } from 'react';
import { useQueryClient } from 'react-query';

export const useAppActivation = () => {
    const queryClient = useQueryClient();

    useEffect(() => {
        const handleAppActivated = () => {
            console.log('🔄 Приложение активировано - обновляем игровые данные');
            
            // Инвалидируем кеш игровых данных
            queryClient.invalidateQueries('gameDataSummary');
            queryClient.invalidateQueries('gameData');
            
            // Также обновляем данные энергии
            window.dispatchEvent(new CustomEvent('refreshEnergyData'));
        };

        // Слушаем событие активации приложения
        window.addEventListener('telegramAppActivated', handleAppActivated);
        
        // Слушаем фокус окна (для браузера)
        const handleWindowFocus = () => {
            console.log('🔄 Окно браузера получило фокус - обновляем данные');
            handleAppActivated();
        };
        
        window.addEventListener('focus', handleWindowFocus);
        
        // Слушаем видимость страницы
        const handleVisibilityChange = () => {
            if (!document.hidden) {
                console.log('🔄 Страница стала видимой - обновляем данные');
                handleAppActivated();
            }
        };
        
        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
            window.removeEventListener('telegramAppActivated', handleAppActivated);
            window.removeEventListener('focus', handleWindowFocus);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [queryClient]);
};
